import { ExperimentNonPaddedRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/experimentNonPaddedRoutes";
import { PersonalizationNonPaddedRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/personalizationNonPaddedRoutes";
import { AiRoutes } from "@src/routes/loggedIn/standardPageRoutes/aiRoutes";

export const StandardNoPaddingRoutes = [
  ...PersonalizationNonPaddedRoutes,
  ...ExperimentNonPaddedRoutes,
];
